<script lang="ts">
    
    import { fly } from 'svelte/transition';
    import { onDestroy, onMount } from "svelte";
    import type { Room } from "../../Model/Room";

    export let room: Room;

    const roomEventsChannel = room.getEventsChannel();

    onMount(() => {
        roomEventsChannel.on('game_created', onGameCreated);
    });

    onDestroy(() => {
        roomEventsChannel.destroy();
    });

    function onGameCreated(): void {
        room.state.set('waiting');
    }

</script>

<div class="monitor-view">

    <img in:fly={{ y: -100, x: -100, delay: 300 }} class="bg-img bg-image-1" src="/images/monitor-idle-background-1.png" alt="">
    <img in:fly={{ y: -100, x: 100, delay: 300 }} class="bg-img bg-image-2" src="/images/monitor-idle-background-2.png" alt="">
    <img in:fly={{ y: 100, x: -100, delay: 300 }} class="bg-img bg-image-3" src="/images/monitor-idle-background-3.png" alt="">
    <img in:fly={{ y: 100, x: 100, delay: 300 }} class="bg-img bg-image-4" src="/images/monitor-idle-background-4.png" alt="">

    <img class="game-logo" src="/images/game-name.png" alt="">
    <img class="company-logo" src="/images/logo.png" alt="">
</div>

<style lang="scss">

    .monitor-view {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .bg-img {
        position: absolute;
    }

    .bg-image-1 {
        top: 0px;
        left: -2%;
        width: 27%;
    }

    .bg-image-2 {
        top: 2%;
        right: -4%;
        width: 38%;
    }

    .bg-image-3 {
        bottom: -4%;
        left: -4%;
        width: 27%;
    }

    .bg-image-4 {
        bottom: 0;
        right: -4%;
        width: 33%;
    }

    .game-logo {
        width: 45%;
    }

    .company-logo {
        width: 60%;
        max-width: 150px !important;
    }

</style>
